export class Adresse{
	complementAdresse: string;
	adresse: string;
	pays: string;
	commune: string;
	codePostal: string;
}